import { collect } from 'collect.js';
import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import { EventHelperTypes } from './Constants';

class HelperMethods {
  triggerEventSideEffects = (eventAction) => {
    ReduxHooks.dispatch(actionCreators.eventHelper.setEvent(eventAction));
  };

  resetEventSideEffects = () => {
    ReduxHooks.dispatch(actionCreators.eventHelper.resetEvent());
  };

  // currency/locale are required — callers resolve them from the company's
  // region (region.currency, region.number_locale) rather than this method
  // guessing from a currency->locale table.
  formatCurrency(amount, currency, locale) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(amount);
  }

  // A bare currency glyph for compact UI (e.g. a preset chip) — derived from Intl rather
  // than a hardcoded symbol table, so it's correct for any currency the backend serves.
  getCurrencySymbol(currency, locale) {
    return (
      new Intl.NumberFormat(locale, { style: 'currency', currency })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value ?? currency
    );
  }

  // luxon date/time format tokens for a region's hour_cycle. date_format itself is already
  // a luxon-consumable token straight from the backend (region.date_format) — no mapping needed.
  timeFormatForHourCycle(hourCycle) {
    return hourCycle === 'h12' ? 'h:mm a' : 'HH:mm';
  }

  // PROD-475: the outlet's own 12h/24h preference, when it has one, beats the region's
  // hour cycle above. Luxon tokens, matching the backend's TranslateDatePatternAction::toPhpTimeFormat().
  // A null preference means nobody chose, so the region's own convention still applies.
  resolveTimeFormat(timeFormat, hourCycle) {
    return (
      {
        '12h': 'h:mm a',
        '24h': 'HH:mm',
      }[timeFormat] ?? this.timeFormatForHourCycle(hourCycle)
    );
  }

  min(...values) {
    return collect(values)
      .filter((item) => !!item)
      .min();
  }

  max(...values) {
    return collect(values)
      .filter((item) => !!item)
      .max();
  }

  triggerLogoutEvent = () => {
    this.triggerEventSideEffects({
      type: EventHelperTypes.LogOut,
    });
  };
}

export default new HelperMethods();
